"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIDEO_CONFIG = exports.IMAGE_CONFIG = exports.EAGER_CACHE = exports.DIRTY_VIDEO_EXTENSIONS = void 0;
var IMAGE_CONFIG = exports.IMAGE_CONFIG = {
  type: 'image',
  mblimit: Infinity,
  uploadPreset: 'AutomaticResize1600x1600',
  types: ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'svg+xml'],
  extensions: ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'svg']
};
var VIDEO_CONFIG = exports.VIDEO_CONFIG = {
  type: 'video',
  mbLimit: 20,
  uploadPreset: 'unsigned',
  types: ['mp4', 'quicktime', 'webm', 'ogg', '3gpp', '3gpp2', 'x-ms-wmv', 'mpeg', 'x-flv', 'x-mkv', 'x-msvideo'],
  extensions: ['mp4', 'mov', 'webm', 'ogv', '3gp', '3g2', 'wmv', 'mpeg', 'flv', 'mkv', 'avi']
};

// Cache on Cloudinary
var EAGER_CACHE = exports.EAGER_CACHE = {
  video: [{
    quality: 90,
    audio_codec: 'none'
  }],
  image: []
};
var DIRTY_VIDEO_EXTENSIONS = exports.DIRTY_VIDEO_EXTENSIONS = ['webm', 'ogv', '3gp', '3g2', 'wmv', 'mpeg', 'flv', 'mkv', 'avi', 'mov'];
//# sourceMappingURL=media-config.js.map